import React,{useEffect,useState} from 'react';
import {motion} from 'framer-motion';
import {fetchPickupOrderAddress} from '../../services/pickupService';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiAlertCircle,FiExternalLink,FiLoader,FiMapPin}=FiIcons;

const formatAddress=(address)=>{
  if (!address) return '';

  return [
    address.line1,
    address.line2,
    [address.city,address.province].filter(Boolean).join(', '),
    [address.postal_code,address.country==='CA' ? 'Canada' : address.country]
      .filter(Boolean)
      .join(' ')
  ].filter(Boolean).join(', ');
};

const PickupAddressCard=({orderId})=>{
  const [address,setAddress]=useState(null);
  const [loading,setLoading]=useState(true);
  const [error,setError]=useState('');

  useEffect(()=>{
    let active=true;

    const loadAddress=async()=>{
      setLoading(true);
      setError('');

      try {
        const result=await fetchPickupOrderAddress(orderId);
        if (active) setAddress(result);
      } catch (loadError) {
        if (active) {
          setError(
            loadError.message || 'Unable to load the pickup location.'
          );
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    loadAddress();

    return ()=>{
      active=false;
    };
  },[orderId]);

  const addressText=formatAddress(address);
  const mapUrl=addressText
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addressText)}`
    : '';

  return (
    <motion.div
      initial={{opacity:0,y:8}}
      animate={{opacity:1,y:0}}
      className="mt-5 rounded-2xl border border-indigo-100 bg-white p-5"
    >
      <div className="flex items-start gap-3">
        <SafeIcon icon={FiMapPin} className="mt-0.5 text-lg text-indigo-600" />
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-black uppercase tracking-widest text-slate-500">
            Pickup location
          </p>
          {loading ? (
            <p className="mt-2 flex items-center text-xs font-bold text-slate-500">
              <SafeIcon icon={FiLoader} className="mr-2 animate-spin" />
              Loading pickup address
            </p>
          ) : error ? (
            <p className="mt-2 flex items-start text-xs font-bold text-red-600">
              <SafeIcon icon={FiAlertCircle} className="mr-2 mt-0.5" />
              {error}
            </p>
          ) : addressText ? (
            <>
              <p className="mt-2 break-words text-sm font-bold leading-relaxed text-slate-900">
                {addressText}
              </p>
              <a
                href={mapUrl}
                target="_blank"
                rel="noreferrer"
                className="mt-3 inline-flex items-center text-[10px] font-black uppercase tracking-widest text-indigo-600 hover:text-indigo-800"
              >
                Open map
                <SafeIcon icon={FiExternalLink} className="ml-2" />
              </a>
            </>
          ) : (
            <p className="mt-2 text-xs font-medium leading-relaxed text-slate-500">
              The seller has not added a pickup address yet. Message the seller before traveling.
            </p>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default PickupAddressCard;
